/*
 *
 * Plans constants
 *
 */

// LOAD
export const LOAD_PLANS = 'app/Plans/LOAD_PLANS';
export const LOAD_PLANS_SUCCESS = 'app/Plans/LOAD_PLANS_SUCCESS';
export const LOAD_PLANS_ERROR = 'app/Plans/LOAD_PLANS_ERROR';

// CHANGE/UPDATE
export const CHANGE_PLANS = 'app/Plans/CHANGE_PLANS';
export const CHANGE_PLANS_SUCCESS = 'app/Plans/CHANGE_PLANS_SUCCESS';
export const CHANGE_PLANS_ERROR = 'app/Plans/CHANGE_PLANS_ERROR';

// DELETE
export const DELETE_PLANS = 'app/Plans/DELETE_PLANS';
export const DELETE_PLANS_SUCCESS = 'app/Plans/DELETE_PLANS_SUCCESS';
export const DELETE_PLANS_ERROR = 'app/Plans/DELETE_PLANS_ERROR';

export const FLUSH_STATE_PLANS = 'app/Plans/FLUSH_STATE_PLANS';
